export default {
  get () {
    return [
      {
        name: 'Devis B2B',
        id: 'devis-b2b',
        has: {
          services: true
        }
      },
      {
        name: 'Communication',
        id: 'communication',
        has: {
          services: true
        }
      },
      {
        name: 'Sellsy ComWeb',
        id: 'sellsy-comweb',
        has: {
          services: false
        }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/source-app.js